import { memo } from "react";

const text = "/// SECURING SITE /// TACTICAL OPERATIONS /// CS2 /// AEONEUH /// LOADING DUST II /// HEADSHOT /// CLUTCH 1v4 /// ACE /// RUSH B /// DEFUSE /// ";

function Marquee() {
  return (
    <section
      className="relative border-y border-white/10 overflow-hidden py-8 md:py-12 bg-[#0a0a0c]"
      data-testid="marquee"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-[#09090b] via-transparent to-[#09090b] z-10 pointer-events-none" />
      <div className="marquee-track flex whitespace-nowrap font-display font-black uppercase text-[8vw] md:text-[6vw] leading-none text-stroke opacity-50">
        <span className="pr-12">{text.repeat(4)}</span>
        <span className="pr-12">{text.repeat(4)}</span>
      </div>
      {/* Second row, opposite direction */}
      <div className="marquee-track-reverse flex whitespace-nowrap font-display font-black uppercase text-[8vw] md:text-[6vw] leading-none text-stroke-orange opacity-20 mt-2">
        <span className="pr-12">{text.repeat(4)}</span>
        <span className="pr-12">{text.repeat(4)}</span>
      </div>
    </section>
  );
}

export default memo(Marquee);
